import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { Modal } from 'react-bootstrap';

const modalWrapperStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100dvh",
  display: "flex",
  justifyContent: "center",
  alignItems: "start",
  zIndex: 1,
  overflow: "hidden",
};

// Start the draggable area at the sidebar's right edge so a modal can't be dragged behind the fixed sidebar
// Below 992px the sidebar is an off-canvas panel (not docked), so no offset is needed
const getModalWrapperStyle = () => {
  const isDesktop = window.innerWidth >= 992;
  const sidebarRight = isDesktop ? document.getElementById("sidebar")?.getBoundingClientRect().right || 0 : 0;
  const left = Math.min(Math.max(0, Math.round(sidebarRight)), Math.round(window.innerWidth / 2));
  return { ...modalWrapperStyle, left, width: `calc(100vw - ${left}px)` };
};

const getModalSizeStyles = (size) => {
  switch (size) {
    case "sm":
      return { width: "300px", maxWidth: "90%" };
    case "lg":
      return { width: "1000px", maxWidth: "95%" };
    default:
      return { width: "500px", maxWidth: "90%" }; // default
  }
};
/**
 * DraggableModalWrapper Component
 * --------------------------------
 * This component wraps a Bootstrap modal in a draggable container.
 * It allows the modal to be moved around the screen.
 * Props:
 * @param {ReactNode} children - The content of the modal.
 * @param {string} size - The size of the modal (default, sm, lg).
 */
const DraggableModalWrapper = ({ children, size = "default" }) => {
  const sizeStyles = getModalSizeStyles(size);
  const [wrapperStyle, setWrapperStyle] = useState(getModalWrapperStyle);
  // Bumping the key remounts Draggable so a stale drag offset is reset after a breakpoint change
  const [layoutKey, setLayoutKey] = useState(0);

  // Recompute the sidebar offset when the viewport changes (mobile <-> desktop) while the modal is open
  useEffect(() => {
    let wasDesktop = window.innerWidth >= 992;
    const onResize = () => {
      setWrapperStyle(getModalWrapperStyle());
      const isDesktop = window.innerWidth >= 992;
      if (isDesktop !== wasDesktop) {
        wasDesktop = isDesktop;
        setLayoutKey((k) => k + 1);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const modalDialogStyle = {
    margin: 0,
    position: "relative",
    maxHeight: "100%",
    display: "flex",
    ...sizeStyles,
  };

  return (
    <div style={wrapperStyle}>
      <Draggable
        key={layoutKey}
        handle=".modal-content"
        bounds="parent"
        cancel=".modal-body,input,textarea,button,select,.react-select__control,.react-select__menu,.react-switch,.nav-tabs,.tab-content, .input-group , .react-select , .toggle-password, [data-tooltip-id]"
      >
        <Modal.Dialog style={modalDialogStyle} >
          {children}
        </Modal.Dialog>
      </Draggable>
    </div>
  );
};

export default DraggableModalWrapper;
